//React imports
import React from 'react';
//Imports the components
import FooterComponent from '../components/home/FooterComponent.js';
import NavBarComponent from '../components/navBar/NavBarComponent.js';
import PrivacyPolicyComponent from '../components/PrivacyPolicyComponent.js';

// import pricingPage from './pricingPage.jsx';
function privacypage() {
    return (
        <div>
            <div className="updated-page-wrapper">

                <NavBarComponent />
                <PrivacyPolicyComponent />
                <FooterComponent />

            </div>
        </div>

    );
}

export default privacypage;
